import { PNotifyService } from './../../../services/pnotify.service';
import { ExcelService } from './../../../services/excel.service';
import { AuthService } from './../../../services/auth.service';
import { IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { Component, OnInit, NgZone } from '@angular/core';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NgxRolesService } from 'ngx-permissions';
import { Router } from '@angular/router';
declare var $;

@Component({
  selector: 'app-general-activity-report',
  templateUrl: './general-activity-report.component.html',
  styleUrls: ['./general-activity-report.component.css']
})
export class GeneralActivityReportComponent implements OnInit {

  filter = {
    clientId: '',
    schoolId: '',
    busIds: [],
    isWeek: true,
    dateInterval: [
      new Date(moment().subtract(6, 'days').format('YYYY-MM-DD')),
      new Date(moment().format('YYYY-MM-DD'))
    ],
  };
  isFirstFilter = true;

  clients: any[];
  schools: any[];
  buses: any[];
  loadData = false;

  public clientsData: any[];
  public schoolsData: any[];

  // ----- Start MultiSelect -----------
  // Settings configuration
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block'
  };
  multiSelectSettingsSchool: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: false,
    showUncheckAll: false,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block',
    selectionLimit: 1,
    autoUnselect: true
  };
  // Text configuration
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'éléments sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a été trouvé...',
    searchNoRenderText: 'Tapez dans la boîte de recherche pour voir les résultats ...',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  // ----- End MultiSelect -----------

  categories: { days: string[], buses: string[] };
  periodPerformance: any[];
  periodMaxSpeed: any[];
  periodMileage: any[];

  Highcharts: typeof Highcharts = Highcharts;
  chart1Options: {};
  chart2Options: {};
  chart3Options: {};

  dateTimeFilter = (d: Date): boolean => {
    return true;
  }

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private excelService: ExcelService,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    this.categories = {
      days: [],
      buses: []
    };
    this.periodPerformance = [[], []];
    this.periodMaxSpeed = [[], []];
    this.periodMileage = [[], []];
    this.initClientSelect();
  }

  ngOnInit() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        this.filter.clientId = clients && clients.length ? clients[0].id : '';
        this.clientsData = this.clients.map((client, index) => {
          return { id: client.id, text: client.name, selected: client.id === this.filter.clientId };
        });
        this.initSchoolSelect();
      });
    }
  }
  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const school = this.authService.getUser().School;
      this.schools = [{ id: school.id, name: school.name }];
      this.filter.schoolId = school.id;
      this.initBusSelect();
    } else {
      const params = new HttpParams({
        fromObject: {
          clientId: this.filter.clientId
        }
      });
      this.http.get(
        '/api/school/lookup',
        { params }
      ).subscribe((schools: any[]) => {
        this.schools = schools;
        this.filter.schoolId = schools && schools.length ? schools[0].id : '';
        this.schoolsData = this.schools.map((school, index) => {
          return { id: school.id, text: school.name, selected: school.id === this.filter.schoolId };
        });
        this.initBusSelect();
      });
    }
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busIds = [];
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      console.log(this.buses);
      for (let i = 0; i < this.buses.length; i++) {
        this.filter.busIds.push(this.buses[i].id);
      }
      if (this.isFirstFilter) {
        this.onFilter();
      }
    });
  }

  onFilter() {
    this.loadData = true;
    const params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId,
        busIds: JSON.stringify(this.filter.busIds),
        activityReportRequest: JSON.stringify(1),
        // period: this.filter.isWeek ? 'week' : 'month',
        dateInterval: JSON.stringify([
          moment(this.filter.dateInterval[0]).format('YYYY-MM-DD'),
          moment(this.filter.dateInterval[1]).format('YYYY-MM-DD')
        ]),
      }
    });
    this.http.get(
      '/api/activityReport',
      { params }
    ).subscribe((data: any) => {
      this.loadData = false;
      this.categories.days = data.days;
      this.categories.buses = data.buses;
      this.periodPerformance = data.periodPerformance.map((dayPerformance, index) => {
        return dayPerformance[0].totalCount ? dayPerformance[0].passedCount / dayPerformance[0].totalCount * 100 : 0;
      });
      this.periodMaxSpeed = data.periodMaxSpeed;
      this.periodMileage = data.periodMileage;
      this.initCharts1Options();
      this.initCharts2Options();
      this.initCharts3Options();
    });
    this.isFirstFilter = false;
  }

  initCharts1Options() {
    this.chart1Options = {
      chart: {
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      colors: ['#f16e00'],
      xAxis: {
        title: {
          text: ''
        },
        labels: {
          rotation: -45,
        },
        categories: this.categories.days,
        lineWidth: 2,
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
        labels: {
          formatter: function () {
            return Math.round(this.value) + '%';
          }
        },
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return Math.round(this.y) + '%';
            }
          },
        },
      },
      series: [
        {
          name: '',
          data: this.periodPerformance,
          // type: 'column'
        }
      ]
    };
  }

  initCharts2Options() {

    this.chart2Options = {
      chart: {
        type: 'line',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        title: {
          text: ''
        },
        labels: {
          rotation: -45,
        },
        categories: this.categories.days
      },
      yAxis: {
        title: {
          text: ''
        },
        plotLines: [{
          value: 0,
          width: 1,
          color: '#808080'
        }],
        labels: {
          formatter: function () {
            return this.value + ' km/h';
          }
        },
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        borderWidth: 0
      },
      // plotOptions: {
      //   series: {
      //     label: {
      //       connectorAllowed: false
      //     },
      //     pointStart: 2010
      //   }
      // },
      series: this.periodMaxSpeed,
    };
  }

  initCharts3Options() {
    this.chart3Options = {
      chart: {
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      colors: ['#f16e00'],
      xAxis: {
        title: {
          text: ''
        },
        labels: {
          rotation: -45,
        },
        categories: this.categories.buses,
        lineWidth: 2,
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Kilométrage',
        },
        labels: {
          formatter: function () {
            return this.value + ' km';
          }
        },
      },
      tooltip: {
        enabled: false,
      },
      legend: {
        enabled: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return this.y + ' km';
            }
          },
        },
      },
      series: [
        {
          name: 'Kilometrage Planifier',
          data: this.periodMileage[0],
          color: '#8BC34A'
        },
        {
          name: 'Kilometrage Réel',
          data: this.periodMileage[1],
          color: '#FFEB3B'
        }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/activity-report/general-activity-report/general-activity-report.component.ts